import React, { Component } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';

import { createContainer } from '@dbk-legacy/muster/react';

class RootView extends Component {
  render() {
    return (
      <div></div>
    );
  }
  componentDidUpdate() {
    this.props.changePage("/dashboard", true);
  }
}

export default createContainer({
  $queries: {
    changePage: {$call: 'ui.history.push'}
  }
})(RootView);
